import React from "react";
// import buttonadd from "../../assets/images/plus.png";
import addIcon from "../../assets/images/add-icon.svg";

const MultipleAddTag = ({ register, errors, tags, setTags }) => {
  // const [tags, setTags] = useState([
  //   {
  //     [`tag${0}`]: "",
  //     id: 0,
  //   },
  // ]);
  const addtag = () => {
    setTags([
      ...tags,
      {
        [`tag${tags.length}`]: "",
        id: tags.length,
      },
    ]);
  };

  const onUpdateEducation = (evt, id) => {
    const list = [...tags];
    const index = list.findIndex((item) => item.id === id);
    if (index === -1) return false;

    list[index][evt.target.name] = evt.target.value;
    setTags(list);
  };

  const removeEducation = (id) => {
    const list = [...tags];
    if (list.length === 1) return false;

    const index = list.findIndex((item) => item.id === id);
    if (index === -1) return false;

    list.splice(index, 1);
    setTags(list);
  };

  return (
    <div className="mb-32 col-9">
      <div className="d-flex justify-content-between">
        <label>Tag {/* <span className="star">*</span> */}</label>{" "}
        <span
          onClick={() => addtag()}
          className="addPlusIcon text-end text-white"
          style={{
            marginLeft: "0px",
            cursor: "pointer",
          }}
        >
          <img src={addIcon} className="mob-plus-icon" alt="Add"></img>
          Add
        </span>
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "column",
          rowGap: "24px",
        }}
      >
        {tags.map((item, idx) => (
          <div
            key={`input-tag-${item.id}`}
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              columnGap: "24px",
            }}
          >
            <div style={{ flexGrow: "1", flexShrink: "0" }}>
              <input
                type="text"
                style={{ width: "100%" }}
                {...register(`tag${item.id}`, {
                  required: false,
                })}
                placeholder="Add Tag"
                defaultValue={item.value || null}
                onInput={(evt) => onUpdateEducation(evt, item.id)}
                className="form-control"
                // autoFocus
              />
              {errors[`tag${item.id}`] && (
                <div className={`invalid-feedback d-block`}>
                  Please provide a Tag
                </div>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                columnGap: "12px",
              }}
            >
              {tags.length > 1 ? (
                <span
                  onClick={() => removeEducation(item.id)}
                  className="plus-icon"
                  style={{
                    marginLeft: "0px",
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span
                    style={{
                      height: "2px",
                      width: "50%",
                      backgroundColor: "#fff",
                    }}
                  ></span>
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MultipleAddTag;
